import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=4ff39cbc&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=4ff39cbc&prod&lang=css&"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=4ff39cbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff39cbc",
  null
  
)

export default component.exports